import { render, staticRenderFns } from "./LimitProductDate.vue?vue&type=template&id=5a3ccc9e&"
import script from "./LimitProductDate.vue?vue&type=script&lang=js&"
export * from "./LimitProductDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports